import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import cogoToast from 'cogo-toast';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { DOWNLOAD_SURGE_LOGS, DOWNLOAD_SURGE_LOGS_SUCCESS, DOWNLOAD_SURGE_LOGS_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

/* Upload logs for one file. `logType` selects which rows are included — ALL by
 * default; the same endpoint also serves INVALID. Like the other download endpoints
 * here, it prepares the file and answers with a pre-signed link rather than bytes. */
function* downloadSurgeLogs({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    delete filteredHeaders['X-Requested-By'];

    const { fileId, logType = 'ALL' } = payload?.data ?? {};

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-file-uploads/${fileId}/logs/${logType}/download`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message ?? 'Log file prepared successfully');
      yield put({
        type: DOWNLOAD_SURGE_LOGS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message ?? 'Could not prepare the log file');
      yield put({
        type: DOWNLOAD_SURGE_LOGS_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: DOWNLOAD_SURGE_LOGS_ERROR, payload: error });
  }
}

export function* watchDownloadSurgeLogs() {
  yield takeEvery(DOWNLOAD_SURGE_LOGS, downloadSurgeLogs);
}

function* downloadSurgeLogsSaga() {
  yield all([fork(watchDownloadSurgeLogs)]);
}

export default downloadSurgeLogsSaga;
